import { createFeatureSelector } from '@ngrx/store';
import { PlanDataState } from '@store/plans/plan.firestore.reducer';
import { FIRESTORE_COLLECTION_PLANS } from '@store/firestore/allFirestoreCollections';

export const planDataState = createFeatureSelector<PlanDataState>(FIRESTORE_COLLECTION_PLANS);
